<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Способ прекращ. по справочнику СЮЛПД</div>
            <div class="dx-field-value">
                <ai-text-box-readonly :value="data.ac_egr_sulpd_name" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const data = inject('serverData');
</script>
